// extracted by mini-css-extract-plugin
export var closed = "_be-1";
export var resizer = "_be-0";